/* eslint-disable no-new */
import SlideInMenu from './components/SlideInMenu';
import SwipperJS from './components/SwipperJS';
import TartoSetup from './components/TartoSetup';
import Alert from './components/Alert';
import Accordion from './components/Accordion';
import Exhibitors from './components/Exhibitors';
import LightboxPicture from './components/LightboxPicture';
import Tabs from './components/Tabs';
import Popup from './components/Popup';
import Header from './components/Header';
import MainExhibitors from './components/exhibitors/MainExhibitors';
import Menu from './components/Menu';
import Parallax from './components/Parallax';
import Newsletter from './components/Newsletter';
import VueComponents from './components/VueComponents';
import CountUp from './components/CountUp';
import LeftRight from './components/LeftRight';
import Prices from './components/Prices';
import Plan from './components/Plan';
import Calendar from './components/Calendar';
import ProgramWeek from './components/ProgramWeek';
import Registration from './components/Registration';

document.addEventListener('DOMContentLoaded', () => {
    new SwipperJS();
    new TartoSetup();
    new Alert();
    new Accordion();
    new SlideInMenu();
    new Exhibitors();
    new LightboxPicture();
    new Tabs();
    new MainExhibitors();
    new Popup();
    Menu.init();
    new Header();
    new Parallax();
    new Newsletter();
    new VueComponents();
    new CountUp();
    new LeftRight();
    new Prices();
    Plan.init();
    new Calendar();
    new Registration();
    new ProgramWeek();
});
